<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('companyEdit.title') }}</h1>
        </v-flex>
      </v-layout>
      <company-form :companyId="companyId" />
    </v-flex>
  </v-layout>
</template>

<script>
import CompanyForm from '@/components/company/CompanyForm.vue';

export default {
  name: 'CompanyPage',
  components: {
    CompanyForm,
  },
  data() {
    return {
      companyId: null,
    };
  },
  computed: {},
  created() {
    const { companyId } = this.$route.params;
    this.companyId = companyId;
  },
};
</script>

<style lang="scss" scoped></style>
